export default __webpack_public_path__ + "static/media/a.767b3fdd.png";